import { RemindersSection } from "@/components/calendars/RemindersSection.tsx";
import { errorToast } from "@/components/ui/toast.tsx";
import { useArtifactViewCtx } from "@/components/artifacts/view/ArtifactViewContext.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";
import type { ReminderOverride } from "@/types/artifacts.ts";

type RemindersComponentData = Extract<ArtifactComponent, { type: "reminders" }>;

export const RemindersBlock = ({ component }: { component: RemindersComponentData }) => {
  const { isReadOnly, patchOne } = useArtifactViewCtx();
  const canEdit = !isReadOnly && component.editable;

  if (!canEdit && (!component.value || component.value.length === 0)) return null;

  const onChange = async (next: ReminderOverride[]) => {
    try {
      await patchOne(component.editPath, next);
    } catch (error) {
      console.error(error);
      errorToast("Error updating reminders");
    }
  };

  return <RemindersSection value={component.value} onChange={onChange} disabled={!canEdit} />;
};
